import { useEffect } from "react";

function useCtrlZEffect(callback) {
  useEffect(() => {
    // console.log("trigger effect")
    function handleKeyDown(event) {
      if (navigator.platform.indexOf("Mac") !== -1) {
        if (event.metaKey && event.key === "z" && !event.shiftKey) {
          callback();
        }
      } else {
        if (event.ctrlKey && event.key === "z" && !event.shiftKey) {
          callback();
        }
      }
    }
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [callback]);
}

export default useCtrlZEffect;
